import type { CSSProperties } from "react";

const groups = [
  { className: "left top", count: 5, seed: 1 },
  { className: "left middle", count: 7, seed: 3 },
  { className: "left bottom", count: 6, seed: 5 },
  { className: "right top", count: 5, seed: 2 },
  { className: "right middle", count: 7, seed: 4 },
  { className: "right bottom", count: 6, seed: 6 }
];

export function CodeLines() {
  return (
    <div className="code-lines" aria-hidden="true">
      {groups.map((group, groupIndex) => (
        <div className={`line-group ${group.className}`} key={group.className}>
          {Array.from({ length: group.count }).map((_, index) => {
            const value = group.seed + groupIndex * 2 + index;
            return (
              <span
                key={index}
                style={{
                  "--delay": `${value * 0.17}s`,
                  "--duration": `${4.6 + (value % 4) * 0.7}s`,
                  "--offset": `${(value % 5) * 22}px`,
                  "--width": `${46 + (value % 6) * 31}px`
                } as CSSProperties}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
